import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/components/shared";

const LINKS = [
  { to: "/", label: "Home", testid: "nav-home-link" },
  { to: "/promotions", label: "Promotions", testid: "nav-promotions-link" },
  { to: "/services", label: "Services", testid: "nav-services-link" },
  { to: "/about", label: "About", testid: "nav-about-link" },
  { to: "/careers-partners", label: "Careers & Partnerships", testid: "nav-careers-link" },
  { to: "/#contact", label: "Contact", testid: "nav-contact-link", anchor: true },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const renderLink = (l, cls) =>
    l.anchor ? (
      <a key={l.label} href={l.anchor && location.pathname === "/" ? "#contact" : l.to}
        data-testid={l.testid} className={cls} onClick={() => setOpen(false)}>
        {l.label}
      </a>
    ) : (
      <Link key={l.label} to={l.to} data-testid={l.testid} className={cls} onClick={() => setOpen(false)}>
        {l.label}
      </Link>
    );

  return (
    <nav className="sticky top-0 z-50 backdrop-blur-md bg-[#0a0a0c]/85 border-b border-[#d4af37]/20 px-6 py-4" data-testid="site-nav">
      <div className="max-w-6xl mx-auto flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0" data-testid="nav-brand-link" onClick={() => setOpen(false)}>
          <img src="/logo-emblem.png" alt="DuroTech28 emblem" className="h-11 w-auto" data-testid="nav-logo" />
          <div className="leading-none hidden sm:block">
            <span className="font-display text-lg tracking-wider text-white">DUROTECH28</span>
            <span className="block text-[9px] uppercase tracking-widest text-[#d4af37] font-mono mt-0.5">Low Voltage Specialist</span>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-6 text-[11px] font-mono uppercase tracking-wider text-zinc-400">
          {LINKS.map((l) => renderLink(l, "hover:text-[#d4af37] transition-colors"))}
        </div>

        <div className="flex items-center gap-3 shrink-0">
          <a href={PHONE_TEL} data-testid="nav-phone-link"
            className="hidden sm:flex items-center gap-2 text-xs font-mono text-zinc-300 hover:text-[#d4af37] transition-colors">
            <Phone className="w-3.5 h-3.5 text-[#d4af37]" />
            <span className="hidden xl:inline">{PHONE_DISPLAY}</span>
          </a>
          <Link
            to="/services"
            data-testid="nav-explore-btn"
            className="px-4 py-2 rounded bg-gradient-to-r from-[#d4af37] to-[#e6ca65] text-black font-semibold uppercase tracking-wider text-xs hover:opacity-90 transition-opacity shadow-[0_0_20px_rgba(212,175,55,0.4)]"
          >
            Explore Services →
          </Link>
          <button type="button" aria-label="menu" onClick={() => setOpen((o) => !o)}
            data-testid="nav-menu-btn"
            className="lg:hidden w-10 h-10 rounded border border-zinc-700 flex items-center justify-center text-zinc-300 hover:border-[#d4af37] transition-colors">
            {open ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#d4af37]/15 mt-4 pt-4 pb-2 flex flex-col gap-1" data-testid="nav-mobile-menu">
          {LINKS.map((l) => renderLink(l, "px-2 py-2.5 text-xs font-mono uppercase tracking-wider text-zinc-300 hover:text-[#d4af37] transition-colors"))}
          <a href={PHONE_TEL} data-testid="nav-mobile-phone"
            className="px-2 py-2.5 text-xs font-mono text-[#d4af37] flex items-center gap-2">
            <Phone className="w-3.5 h-3.5" /> {PHONE_DISPLAY}
          </a>
        </div>
      )}
    </nav>
  );
}
